module.exports = __webpack_public_path__ + "static/media/CaptureTheGuy.1de2fe6e.md";